// extracted by mini-css-extract-plugin
export default {"root":"Web2DT"};